export default __webpack_public_path__ + "static/media/Artboard 9@4x-8.12ec2add.png";